import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Legacy route — always redirect to login instead of showing check-email page.
 */
const CheckEmailPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", {
      replace: true,
      state: { recoveryEmailSent: true },
    });
  }, [navigate]);

  return null;
};

export default CheckEmailPage;
